<template>
  <a-date-picker
    :value="value"
    :placeholder="placeholder"
    @change="dataChange"
    :style="{ width: props.width }"
    v-if="!props.disabled"
    :allowClear="props.allowClear"
  />
  <span class="comValue" v-else>{{ comValue }}</span>
</template>

<script setup>
  import {
    reactive,
    ref,
    toRaw,
    defineProps,
    defineEmits,
    watch,
    computed,
  } from 'vue'
  import dayjs from 'dayjs'
  const emit = defineEmits()

  const props = defineProps({
    modelValue: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    //传入的日期是否是格式化的日期，如2024-1-2,就true
    valueFormat: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    width: {
      default: '100%',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  })
  const comValue = computed(() => {
    if (props.valueFormat) {
      return dayjs(props.modelValue).format(props.format)
    } else {
      return props.modelValue
    }
  })
  const placeholder = props?.placeholder
    ? props?.label?.placeholder
    : `请选择${props?.label}`

  function dataChange(data) {
    //   console.log('🚀  dataChange  data:', data)
    //   emit('update:modelValue', data?.target?.value)
    if (props.valueFormat) {
      emit('update:modelValue', data.format(props.format))
    } else {
      emit('update:modelValue', data)
    }
  }

  const value = computed(() => {
    if (props.valueFormat) {
      if (props.modelValue) {
        return dayjs(props.modelValue)
      }
      if (props.defaultPickerValue) {
        return dayjs(props.defaultPickerValue)
      }
      return
    } else {
      return props.valueFormat
    }
  })
</script>

<style lang="less" scoped></style>
